import { AbstractModel } from './abstract-model';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class TransitProgram extends AbstractModel {
  @autoserialize
  acceptingDrivers: boolean;

  @autoserialize
  acceptingRides: boolean;

  @autoserialize
  active: boolean;

  @autoserialize
  automaticTollDetectionEnabled: boolean;

  @autoserialize
  autopairInitialWaitPeriodInMinutes: number;

  @autoserialize
  autopairInterestedDriversTriggerAmount: number;

  @autoserialize
  autopairMinutesBeforePickupToForce: number;

  @autoserialize
  autopairOnDemandInitialWaitPeriodMinutes: number;

  @autoserialize
  autopairOnDemandOptimisticMinutes: number;

  @autoserialize
  autopairTriggerWaitPeriodInPercent: number;

  @autoserialize
  autopairingEnabled: boolean;

  @autoserialize
  clientCancellationWindowMinutes: number;

  @autoserialize
  code: string;

  @autoserialize
  driverCancellationFee: number;

  @autoserialize
  driverCallCenterPhoneNumber: string;

  @autoserialize
  flatTax: number;

  @autoserialize
  ftaCompliant: boolean;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  lyftAutoDispatchEnabled: boolean;

  @autoserialize
  lyftEnabled: boolean;

  @autoserialize
  maximumVehicleAgeInYears: number;

  @autoserialize
  minutesAfterPickupConsideredLate: number;

  @autoserialize
  minutesBeforePickupToFallback: number;

  @autoserialize
  name: string;

  @autoserialize
  nonacceptedCutoffTime: string;

  @autoserialize
  onDemandOnTimeWindowMinutes: number;

  @autoserialize
  organizationId: number;

  @autoserialize
  operationalFootprintId: number;

  @autoserialize
  providerCancellationWindowMinutes: number;

  @autoserialize
  riderCallCenterPhoneNumber: string;

  @autoserialize
  riderCancellationWindowMinutes: number;

  @autoserialize
  riderPaymentAccountRequired: boolean;

  @autoserialize
  sendRidesInFeedReminders: boolean;

  @autoserialize
  stateCode: string;

  @autoserialize
  taxPercent: number;

  @autoserialize
  timeZone: string;

  @autoserialize
  vehicleInspectionRequired: boolean;

  @autoserialize
  description: string;

  @autoserialize
  pickupTimeBufferMinutes: number;

  @autoserialize
  journeyWithholdingPeriodSeconds: number;

  @autoserialize
  journeyWithholdingForceWindowSeconds: number;

  @autoserialize
  driverHubLink: string;

  @autoserialize
  onboardingGuideLink: string;

  @autoserialize
  rideReviewEnabled: boolean;
}
